/**
 * Funnel session id for public candidate apply → interview (passed as ?sid=).
 * sessionStorage: one id per tab session; not tied to candidate_id.
 */
export const CANDIDATE_MIXPANEL_SESSION_KEY = "onlyround_mixpanel_session_id"

/** Public apply routes (web + phone) — create session only here, not on recruiter pages */
const PUBLIC_APPLY_PATH = /\/(jobDetails(V2)?|reschedule)\//

export function getOrCreateCandidateSessionId(): string | null {
    if (typeof window === "undefined") return null
    try {
        const existing = sessionStorage.getItem(CANDIDATE_MIXPANEL_SESSION_KEY)
        if (existing) return existing
        if (!PUBLIC_APPLY_PATH.test(window.location.pathname)) return null
        const sessionId = crypto.randomUUID()
        sessionStorage.setItem(CANDIDATE_MIXPANEL_SESSION_KEY, sessionId)
        return sessionId
    } catch {
        return null
    }
}

/** For redirects: must exist before leaving apply flow (call after tracks on same page). */
export function getCandidateSessionIdForRedirect(): string | null {
    return getOrCreateCandidateSessionId()
}
